import PropTypes from 'prop-types'
import { toast } from 'react-toastify'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import Input from '../../../../../common/form/Input'
import SubmitButton from '../../../../../common/buttons/SubmitButton'

import { transferStudentToProgram, inviteStudentToAnotherProgram } from '../../../../../../actions/waitlistActions'
import { isOnlineOnly } from '../../../../../../utility/programHelper'
import { reset as resetDualPanelData } from '../../../../../../reducers/dualPanelSelectorReducer'

import classes from './MoveToAnotherProgramForm.module.scss'


const MoveToAnotherProgramForm = (
  { course, selectedCourse, waitlistEntry, closeModal }
) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const isLoading = useSelector(state => state.waitlist.isLoading)
  const [coachMessage, setCoachMessage] = useState('')

  const targetIsOnlineOnly = isOnlineOnly(selectedCourse.paymentMethod)

  const handleMoveStudentFromWaitlist = () => {
    dispatch(transferStudentToProgram({ course: selectedCourse, waitlistEntry, coachMessage }))
      .unwrap()
      .then(() => dispatch(resetDualPanelData()))
      .catch(() => toast.error(t('programs.manage.moveToAnotherProgramForm.somethingWentWrong'), { position: toast.POSITION.TOP_RIGHT }))
      .finally(() => closeModal())
  }

  const handleSendRegistrationLink = () => {
    dispatch(inviteStudentToAnotherProgram({ course, waitlistEntry, coachMessage, targetCourseId: selectedCourse.id }))
      .unwrap()
      .then(() => dispatch(resetDualPanelData()))
      .catch(() => toast.error(t('programs.manage.moveToAnotherProgramForm.somethingWentWrong'), { position: toast.POSITION.TOP_RIGHT }))
      .finally(() => closeModal())
  }

  return (
    <>
      <div className='d-flex flex-column justify-content-center'>
        <Input
          name='description'
          type='textarea'
          onChange={(e) => setCoachMessage(e.target.value)}
          placeholder={t('programs.common.messageToGolfers')}
          value={coachMessage}
          classNames={{
            inputContainer: classes.coachMessageInputContainer,
            inputContainerWrapper: 'mt-2',
          }}
        />
      </div>
      <div>
        <div className='row py-3 justify-content-center align-items-center'>
          <div className='col-12'>
            {targetIsOnlineOnly && (
              <SubmitButton
                onClick={handleSendRegistrationLink}
                buttonMessage={t('programs.manage.moveToAnotherProgramForm.sendRegistrationLink')}
                buttonColor='orange-button'
                loading={isLoading}
                disabled={isLoading}
              />
            )}
            <SubmitButton
              onClick={handleMoveStudentFromWaitlist}
              buttonMessage={t('programs.manage.moveToAnotherProgramForm.confirmAndMoveStudent')}
              buttonColor='orange-button'
              loading={isLoading}
              disabled={isLoading || targetIsOnlineOnly}
            />
          </div>
        </div>
      </div>
    </>
  )
}

MoveToAnotherProgramForm.propTypes = {
  course: PropTypes.shape({ id: PropTypes.number }).isRequired,
  selectedCourse: PropTypes.object.isRequired,
  waitlistEntry: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
  closeModal: PropTypes.func,
}

export default MoveToAnotherProgramForm
